
import { useParams } from 'react-router-dom';
import React, { useState } from "react";

import {
  AppLayout,
  BreadcrumbGroup,
  Button,
  Container,
  ContentLayout,
  Flashbar,
  Header,
  HelpPanel,
  Input,
  Link,
  SideNavigation,
  SpaceBetween,
  SplitPanel,
} from "@cloudscape-design/components";
// import { Navigation } from "../../../components/app/Navigation";
import Icon from "@cloudscape-design/components/icon";
// import { dataUnit } from "../../dashboard/data";
// import { Grid,  } from '@cloudscape-design/components';
import DetailDashboard from './component/DetailDashboard';
import { Navigation } from '../../../components/app/Navigation';


 




const TyreAlarmDetail: React.FC = () => {
    
    const [activeHref, setActiveHref] = React.useState("/vehicles/tyres/alarms");
    const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
    const { name } = useParams<{ name: string }>();

    let { SerialNumber } = useParams();
  
   
  
  
    return (
      <>
        <AppLayout
          breadcrumbs={
            <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles", 
              },
              {
                text: "Tyres",
                href: "/vehicles/tyres", 
              },
              {
                text: "Alarms",
                href: "/vehicles/tyres/alarms", 
              },
              {
                text: `S/N : ${SerialNumber}`,
                href: `/vehicles/tyres/alarms/${SerialNumber}`, 
              },
            ]}
            />
          }
          navigation={
            <Navigation
              activeHref={activeHref}
              setActiveHref={setActiveHref} adminSubMenuOpen={false} setAdminSubMenuOpen={function (href: boolean): void {
                throw new Error('Function not implemented.');
              } }              // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
              // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
            />
          }
          //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
          //notifications={
          //  <Flashbar
          //    items={[
          //      {
          //        type: "info",
          //        dismissible: true,
          //        content: "This is an info flash message.",
          //        id: "message_1",
          //      },
          //    ]}
          //  />
          //}
          toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
          onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
          tools={
            <HelpPanel
              footer={
                <div>
                  <h3>
                    Learn more <Icon name="external" />
                  </h3>
                  <ul>
                    <li>
                      <a href="">Link to documentation</a>
                    </li>
                    <li>
                      <a href="">Link to documentation</a>
                    </li>
                  </ul>
                </div>
              }
              header={<h2>Help panel title (h2)</h2>}
            >
              <div>
                <p>
                  This is a paragraph with some <b>bold text</b> and also some{" "}
                  <i>italic text</i>.
                </p>
  
                <h3>h3 section header</h3>
                <ul>
                  <li>Unordered list item.</li>
                  <li>Unordered list item.</li>
                </ul>
  
                <h4>h4 section header</h4>
                <p>
                  Code can be formatted as lines of code or blocks of code. Add
                  inline code <code>like this</code> using a{" "}
                  <code>{"<code>"}</code> tag.
                  <pre>
                    Or format blocks of code (like this) using a{" "}
                    <code>{"<pre>"}</code> tag.
                  </pre>
                </p>
  
                <h5>h5 section header</h5>
                <dl>
                  <dt>This is a term</dt>
                  <dd>This is its description.</dd>
                  <dt>This is a term</dt>
                  <dd>This is its description</dd>
                </dl>
              </div>
            </HelpPanel>
          }
          content={
            <ContentLayout
              header={
                <Header
                  variant="h1"
                  actions={
                    <SpaceBetween size="s" direction="horizontal">
                    
                    <Button>Edit</Button>
                    <Button>Delete</Button>
                  </SpaceBetween>
                  }
                  info={
                    <Link
                      variant="info"
                      onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                    >
                      Info
                    </Link>
                  }
                  
                >
                  {activeHref === "/vehicles/tyres/alarms"
                    ? `S/N : ${SerialNumber}`
                    : ""}
                </Header>
              }
            >
              
                <div className="contentPlaceholder">
                 <DetailDashboard />
                </div>
             
            </ContentLayout>
          }
          splitPanel={
            <SplitPanel header="Split panel header">
              Split panel content
            </SplitPanel>
          }
        />
      </>
    );
  }
  
  export default TyreAlarmDetail;
 